<!-- @veltra/icons generated sha256:53edbfa00229f3a3 gen:8 source:src/svg/normal/edit-pen.svg -->
<script setup lang="ts">
defineOptions({ name: 'EditPen' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m11.246 2.064 2.53 2.53a.507.507 0 0 0 .712 0l.008-.008a.49.49 0 0 0-.014-.7l-2.53-2.529a.507.507 0 0 0-.712 0l-.008.007a.49.49 0 0 0 .014.7m-8.887 11.77 3.613-.723 6.599-6.6a.98.98 0 0 0-.002-1.398L10.727 3.27a.98.98 0 0 0-1.4-.002l-6.598 6.6-.723 3.612a.3.3 0 0 0 .353.353m7.806-9.711 1.552 1.552c.078.078.077.2-.001.278L5.479 12.19l-1.991.398a.2.2 0 0 1-.236-.236l.398-1.992 6.236-6.236c.078-.078.2-.08.279-.001M11.5 11h2.998c.276 0 .501.228.501.496a.504.504 0 0 1-.5.504h-3a.5.5 0 0 1-.5-.496c0-.276.225-.504.5-.504m-2.508 2h5.514c.276 0 .493.228.493.496a.497.497 0 0 1-.493.504H8.993a.495.495 0 0 1-.493-.496c0-.276.217-.504.493-.504"
      style="opacity: 0.9000000357627869"
    />
  </svg>
</template>
